import { render, staticRenderFns } from "./MenuCollapseItemContent.vue?vue&type=template&id=2fb4b266&"
import script from "./MenuCollapseItemContent.vue?vue&type=script&lang=js&"
export * from "./MenuCollapseItemContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports